import React, { FunctionComponent, ChangeEvent } from 'react';
import { DebounceInput } from 'react-debounce-input';
import { useTranslation } from 'react-i18next';
import { DATA_QA } from '../../../helpers/data-qa';
import { NewsForgeErrorState } from '../../../helpers/news-forge.helper';
import { useDispatch } from 'react-redux';
import { updateNewsForgeContent } from '../../../../../../store/action-creators/news-forge-action-creator';
import { INewsForgeTranslationContent } from '../../../models/news-forge.models';
import '../../../styles/news-forge.styles.scss';

type Properties = {
	errorState: NewsForgeErrorState;
	errorMessage: string | undefined;
	setErrorState: (errorState: NewsForgeErrorState) => void;
	newsForgeContent: INewsForgeTranslationContent;
};

const TargetUrlInput: FunctionComponent<Properties> = ({ newsForgeContent, errorMessage, errorState, setErrorState }) => {
	const { t } = useTranslation();
	const dispatch = useDispatch();

	const onTargetUrlChange = (event: ChangeEvent<HTMLInputElement>) => {
		const inputText = event.target.value || '';

		dispatch(
			updateNewsForgeContent({
				...newsForgeContent,
				target_url: inputText,
			}),
		);

		setErrorState({
			...errorState,
			target_url: false,
		});
	};

	return (
		<div className='news-forge-input-fields-group' data-qa={DATA_QA.NEWS_FORGE_URL_LINK}>
			<span className='input-fields-label'>{t('import_url_link')}</span>
			<DebounceInput
				id={DATA_QA.NEWS_FORGE_URL_LINK}
				debounceTimeout={300}
				type='text'
				element='input'
				className={`target-url-field ${errorMessage ? 'error-state' : ''}`}
				placeholder={t('url_placeholder')}
				value={newsForgeContent && newsForgeContent.target_url ? newsForgeContent.target_url : ''}
				onChange={onTargetUrlChange}
			/>
			{errorMessage && (
				<div className='error-container'>
					<span className='error-icon' />
					<div className='error-message'> {errorMessage} </div>
				</div>
			)}
		</div>
	);
};

export default TargetUrlInput;
